import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  Flex,
  Text,
  useColorModeValue,
  Icon,
} from "@chakra-ui/react";
import { useRef } from "react";
import { IoAlertCircle } from "react-icons/io5";

export interface iconProps {
  width?: number | string | {};
  heigth?: number | string | {};
  display?: string;
  [StyleCSS: string]: number | string | {};
}

export default function AlertModal(props: {
  title?: string;
  message: string | JSX.Element;
  status?: string;
  disclosure: any;
  afterCloseAction?: () => void;
  iconProps?: iconProps;
  buttons?: JSX.Element;
  titleProps?: any;
  messageProps?: any;
  [x: string]: any;
}) {
  const { isOpen, onClose } = props.disclosure;
  const { title, message, status, afterCloseAction, iconProps, titleProps, messageProps, buttons } = props;
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const brandColor = useColorModeValue("brand.500", "white");
  const okRef = useRef();
  return (
    <AlertDialog
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={okRef}
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay bg="blackAlpha.300" backdropFilter="blur(10px)">
        <AlertDialogContent>
          {title ? <AlertDialogHeader {...titleProps}>{title}</AlertDialogHeader> : null}
          <AlertDialogBody>
            <Flex w="100%">
              <Icon
                {...(iconProps
                  ? {...iconProps}
                  : { width: "70px", height: "100px" })}
                mr="25px"
                color={
                  status
                    ? status === "error"
                      ? "red"
                      : status === "warning"
                      ? "yellow"
                      : "blue"
                    : brandColor
                }
                as={IoAlertCircle}
              />
              <Text as="div" color={textColorSecondary} alignSelf='center' {...messageProps}>
                {message}
              </Text>
            </Flex>
          </AlertDialogBody>
          <AlertDialogFooter>
            {buttons ? (
              buttons
            ) : (
              <Button
                onClick={() => {
                  onClose();
                  afterCloseAction();
                }}
                ref={okRef}
                color={textColorPrimary}
              >
                Entendido
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
